import * as React from 'react';
import FontSizePicker from '../FontSizePicker';
import RibbonButton from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { setFontSize } from 'roosterjs-editor-api';

const fontSize: RibbonButton = {
    key: 'fontSize',
    title: () => strings.fontSize,
    imageSrc: require('../svg/fontsize.svg'),
    createDropDownCallback: (target, plugin, dismiss, logUsage) => (
        <FontSizePicker
            menuTargetElement={target}
            onDismissMenu={dismiss}
            onSelectSize={fontSize => {
                setFontSize(plugin.getEditor(), fontSize + 'pt');
                logUsage('setFontSize', fontSize + 'pt');
            }}
            selectedSize={plugin.getFormatState().fontSize}
        />
    ),
};

export default fontSize;
